export enum StorageKeys {
    selectedAddress = '@app/user/addressId',
    deprecatedSelectedAddress = 'selectedAddressId',
    anonAddresses = 'anonymousAddresses',
    anonSelectedAddress = 'anonymousSelectedAddresses',
    servicesIdentity = 'servicesIdentity',
    deviceId = 'device-id',
}
